<template>
    <div class="sub_contents">
        <div class="cont_center">
            <h1 class="title_page">이용약관</h1>

            <div class="term_select_area">
                <SelectBox :optionName="selectTitle" :items="termsList" dropdownId="d1"
                    @itemSelected="onchangeTermsValue" />
            </div>

            <div class="term_area" v-html="termsContent">

            </div>
        </div>
    </div>
</template>

<script>
import SelectBox from '@/components/SelectBox'
import { ref, watch, nextTick } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { getAxios } from '@/lib/AxiosCall';

export default {
    components: {
        SelectBox
    },
    data() {
        return {
        }
    },
    setup() {
        let tempList = ref([{}]);
        let termsList = ref([{}]);
        let termsContent = ref('');
        let selectTitle = ref('현재 이용 약관');

        const termsReqData = ref({
            contractType: 'CONTRACT_AGREEMENT',
            disp: ''
        });

        const termsData = useQuery({
            queryKey: ['get-branch-store', new Date().getTime(), termsReqData.value],
            queryFn: () => getAxios("/hvm/v1/help/contract", termsReqData.value),
            enabled: true,
        });
        termsData.refetch();

        watch(() => termsData.data.value, (newData) => {
            if (newData && newData.page && newData.page.list) {
                tempList.value = newData.page.list;

                for (var i = 0; i < tempList.value.length; i++) {
                    termsList.value = tempList.value.map(item => ({ name: item.title, value: item.rmks }));
                }

                if (termsList.value.length > 0) {
                    selectTitle.value = termsList.value[0].name;
                    onchangeTermsValue(termsList.value[0].value);
                }

            }
        });

        const onchangeTermsValue = (selectedValue) => {
            nextTick(() => {
                termsContent.value = selectedValue;
            });
        };

        return { tempList, termsReqData, termsData, termsList, termsContent, selectTitle, onchangeTermsValue };


    },
    methods: {
        toggleEvent(idx) {
            this.classData.forEach((e, index) => {
                index === idx ? e.isActive = true : e.isActive = false
            })
        }
    }
}
</script>